module.exports = __webpack_public_path__ + "static/media/microphone.e72f25b2.svg";